import axios from '@/plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async fetch({ commit }, { discount_id }) {
            const { data } = await axios.get(`/admin/discounts/${ discount_id }/schedules`);
            commit('SET_ENTITIES', data);
            return data;
        },
        async get({ commit }, { discount_id, id }) {
            const { data } = await axios.get(`/admin/discounts/${ discount_id }/schedules/${ id }`);
            commit('SET_ENTITY', data);
        },
        async save({ commit, state }, { discount_id }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/discounts/${ discount_id }/schedules/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post(`/admin/discounts/${ discount_id }/schedules`, state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { discount_id, id }) {
            await axios.delete(`/admin/discounts/${ discount_id }/schedules/${ id }`);
        },
    },

    getters: {}
}
